import { RoleName } from 'utils/enums/Role';
import { HarlowRouter } from '../../../@types/router';
import { externalRoutes } from './externalList';
import { availableRoutes } from './list';

const routes: HarlowRouter.RouteList = {
  public: [{
    path: availableRoutes.error[404],
    exact: true,
    componentPath: 'Errors/404', // screens/Errors/404
  },
  {
    path: availableRoutes.newUser,
    exact: true,
    componentPath: 'NewUser', // screens/NewUser
  },
  {
    path: availableRoutes.signUp,
    exact: false,
    componentPath: 'SignUp', // screens/SignUp
  },
  {
    path: availableRoutes.signUpSuccess,
    exact: false,
    componentPath: 'SignUp/SignUpSuccess', // screens/SignUp/Success
  },
  {
    path: availableRoutes.login,
    exact: true,
    componentPath: 'Login', // screens/Login
  },
  {
    path: availableRoutes.joinOrganization,
    exact: true,
    componentPath: 'JoinOrganization', // screens/JoinOrganization
  },
  {
    path: availableRoutes.proposalAndContractView,
    exact: true,
    componentPath: 'ProposalAndContracts/Previews/PublicView', // screens/ProposalAndContracts/Preview/PublicView
  },
  {
    path: availableRoutes.invoiceView,
    exact: true,
    componentPath: 'Finances/InvoicePublicView/InvoicePublicView', // screens/Finances/InvoicePublicView/InvoicePublicView
  },
  {
    path: availableRoutes.requestResetPassword,
    exact: true,
    componentPath: 'RequestResetPassword', // screens/RequestResetPassword
  },
  {
    path: availableRoutes.resetPassword,
    exact: true,
    componentPath: 'ResetPassword', // screens/RequestResetPassword
  },
  ],
  private: [{
    path: availableRoutes.dashboard,
    exact: false,
    componentPath: 'Dashboard', // screens/Dashboard
  },
  {
    path: availableRoutes.error.media,
    exact: true,
    componentPath: 'Errors/MediaError', // screens/Errors/404
  },
  {
    path: availableRoutes.clients,
    exact: true,
    componentPath: 'Clients', // screens/Clients
  }, {
    path: availableRoutes.clientDetails,
    exact: false,
    componentPath: 'Clients/Details', // screens/Clients/id
  }, {
    path: availableRoutes.proposalAndContracts,
    exact: true,
    componentPath: 'ProposalAndContracts', // screens/ProposalAndContracts
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.proposalAndContractsTemplates,
    exact: true,
    componentPath: 'ProposalAndContracts/Templates', // screens/ProposalAndContracts/Template
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.proposalAndContractTemplateEdit,
    exact: true,
    componentPath: 'ProposalAndContracts/EditTemplate', // screens/ProposalAndContracts/EditTemplate
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.proposalAndContractTemplateNew,
    exact: true,
    componentPath: 'ProposalAndContracts/NewTemplate', // screens/ProposalAndContracts/NewTemplate
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.proposalAndContractEdit,
    exact: true,
    componentPath: 'ProposalAndContracts/Edit', // screens/ProposalAndContracts/Edit
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    // Single route handles both `/tasks` and `/tasks/:id` so navigating
    // between them doesn't unmount Tasks and refetch the table.
    path: '/tasks/:id?',
    exact: true,
    componentPath: 'Tasks', // screens/Tasks
  },
  {
    path: availableRoutes.finances,
    exact: true,
    componentPath: 'Finances', // screens/Finances
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.invoices,
    exact: true,
    componentPath: 'Finances/Invoice/Invoice', // screens/Finances/InvoiceForm
    hideOnMedia: ['mobile'],
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.invoicesDetails,
    exact: true,
    componentPath: 'Finances/Invoice/Invoice', // screens/Finances/InvoiceForm/id
    notAllowedRoles: [RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.timetracking,
    exact: false,
    componentPath: 'TimeTracking', // screens/TimeTracking
  },
  {
    path: availableRoutes.billingAndSuscription,
    exact: false,
    componentPath: 'BillingAndSuscription', // screens/BillingAndSuscription
    notAllowedRoles: [RoleName.TEAMMATE, RoleName.COLLABORATOR],
  },
  {
    path: availableRoutes.settings,
    exact: false,
    componentPath: 'Settings', // screens/Settings
  },
  {
    path: availableRoutes.stripeConnect,
    exact: true,
    componentPath: 'Stripe', // screens/Stripe
  },
  ],
  previews: [
    {
      path: availableRoutes.proposalAndContractTemplatePreview,
      exact: true,
      componentPath: 'ProposalAndContracts/Previews/HarlowTemplatePreview', // screens/ProposalAndContracts/Previews/id
    },
    {
      path: availableRoutes.proposalAndContractCustomTemplatePreview,
      exact: true,
      componentPath: 'ProposalAndContracts/Previews/CustomPreview', // screens/ProposalAndContracts/Custom/Previews/id
    },
    {
      path: availableRoutes.proposalAndContractPreview,
      exact: true,
      componentPath: 'ProposalAndContracts/Previews/ProposalPreview', // screens/ProposalAndContracts/Custom/Previews/id
    },
    {
      path: availableRoutes.invoicesPreview,
      exact: true,
      componentPath: 'Finances/InvoicePreview', // screens/Finances/InvoicePreview
    },
  ],
};

export {
  routes,
  availableRoutes,
  externalRoutes,
};
